
import { Options, Vue } from 'vue-class-component';
import BusquedaConFiltros from '@/components/BusquedaConFiltros.vue';
import ListadoAgrupacionesProfesiones from '@/components/profesiones/ListadoAgrupacionesProfesiones.vue';
import FiltrosProfesiones from '@/components/profesiones/FiltrosProfesiones.vue';
import FiltroProfesiones from '@/model/filtros/FiltroProfesiones';
import { Prop } from 'vue-property-decorator';
import { searchData } from '@/api/ProfesionesApi';
import { notifyError } from '@/utils/NotifyUtils';
import Profesion from '@/model/Profesion';
import { mapToPageablePayload } from '@/utils/ApiUtils';

@Options({
  components: { BusquedaConFiltros, ListadoAgrupacionesProfesiones, FiltrosProfesiones },
  name: 'BusquedaProfesiones',
})
export default class BusquedaProfesiones extends Vue {
  async mounted() {
    await this.buscar();
  }
  @Prop({ type: String, default: 'Búsqueda' })
  private titulo!: string;

  @Prop({ default: false, type: Boolean })
  private loadingListado = false;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  private loading = false;

  private dialog = false;

  private page: any = {};

  private id = 0;

  private showListado = true;

  private filtro: FiltroProfesiones = this.createNewInstance();
  FiltroProfesionesForm(): Vue & {
    validate: () => boolean;
    resetValidation(): void;
  } {
    return this.$refs.filtroComponent as Vue & {
      validate: () => boolean;
      resetValidation(): void;
    };
  }

  createNewInstance(): FiltroProfesiones {
    return new FiltroProfesiones();
  }

  private localVal = undefined as unknown as any;

  async buscar(val?: any) {
    this.loading = true;
    if (val?.rowsPerPage) {
      this.localVal = val;
    } else if (this.localVal) {
      val = this.localVal;
    }
    const page = val && val.page ? val.page : 1;

    const size = val && val.rowsPerPage ? val.rowsPerPage : 15;

    try {
      if (this.FiltroProfesionesForm().validate()) {
        this.page = mapToPageablePayload<Profesion>(
          await searchData(`?page=${page - 1}&size=${size}${this.filtro.toQuerystring()}`)
        );
      }
    } catch (err) {
      console.log({ err });
      notifyError(err);
    } finally {
      this.loading = false;
    }
  }

  limpiar() {
    this.page = {};
    this.localVal = {};
    this.filtro = new FiltroProfesiones();
    this.$nextTick(() => {
      this.buscar();
    });
    this.showListado = true;
  }
}
